import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents/Box';
import { Row } from '~/commonComponents/Row';

export const CalendarLegends = () => (
  <Row paddingHorizontal={16} paddingVertical={14} alignItems="center" gap={12}>
    <Typography as="span" variant="body1" bold>
      Shift Legend:
    </Typography>
    <Row gap={12}>
      {[
        { label: 'Today', color: colors.primary[500] },
        { label: 'Action Needed', color: colors.error[450] },
        { label: 'Scheduled', color: colors.secondary[500] },
        { label: 'Open', color: colors.success[500] },
        { label: 'Completed', color: colors.neutral[300] },
        { label: 'Cancelled & Expired', color: colors.warning[700] },
      ].map(({ label, color }) => (
        <Row key={label} marginLeft={10} alignItems="center" gap={8}>
          <Box backgroundColor={color} borderRadius="100%" height={14} width={14} />
          <Typography as="span" color={colors.neutral[500]} variant="body1" style={{ lineHeight: '16px' }}>
            {label}
          </Typography>
        </Row>
      ))}
    </Row>
  </Row>
);
